import { createHead } from '@vueuse/head'

export const head = createHead()
